import { ERouteHttpVerb } from "@devowl-wp/api";
export const locationRestPluginGet = {
    path: "/plugin",
    method: ERouteHttpVerb.GET
};
